import { dark, type LayoutFn } from "../src";

export const W = 80;
export const C = dark;
export const BC = C.border;

export const MD_STYLE = {
  headingMarker: C.brightBlack,
  paragraph: C.white,
  unorderedBullet: C.cyan,
  tableHeader: C.cyan,
  tableBorder: BC,
  quoteMarker: C.brightBlack,
  quoteText: C.brightBlack,
  codeText: C.brightWhite,
  codeBorder: BC,
};

export const SPARK_A = [3, 5, 2, 8, 6, 9, 4, 7, 8, 5, 6, 9, 7, 4, 8, 6, 3, 7, 9, 8, 5, 7, 6, 9];
export const SPARK_B = [9, 6, 7, 5, 8, 9, 7, 3, 6, 8, 4, 7, 9, 8, 5, 6, 9, 2, 4, 7, 6, 8, 5, 3];
export const SPINNER_FRAMES = ["\u280b", "\u2819", "\u2839", "\u2838", "\u2834", "\u2826", "\u2827", "\u2807", "\u280f"];

const clockFmt = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: false,
});

export function clockNow(): string {
  return clockFmt.format(new Date());
}

export function clamp(n: number, mn: number, mx: number): number {
  return Math.max(mn, Math.min(mx, n));
}

export function nfmt(n: number): string {
  return n.toLocaleString("en-US");
}

export function toFixed(n: number, d = 1): string {
  return n.toFixed(d);
}

export function rot<T>(a: T[], tick: number): T[] {
  if (a.length === 0) return a;
  const shift = ((tick % a.length) + a.length) % a.length;
  return a.slice(shift).concat(a.slice(0, shift));
}

export type DemoTermElement = HTMLElement & {
  layout?: LayoutFn | null;
  render: () => void;
};

export function setTermLayout(term: DemoTermElement, layout: LayoutFn): void {
  term.layout = layout;
  term.render();
}
